import { vatRates } from "./rates.js";
export const vatRateTypes = [
    "standard",
    "reduced1",
    "reduced2",
    "reduced3",
    "reduced",
    "zero",
    "custom",
];
export const getAvailableVatRateTypes = (countryCode = "DE") => {
    const countryRates = vatRates.find(r => r.countryCode === countryCode) ??
        vatRates.find(r => r.countryCode === "DE");
    return vatRateTypes.filter(rate => rate in countryRates.rates);
};
export const getAvailableVatRateValues = (countryCode = "DE") => {
    const countryRates = vatRates.find(r => r.countryCode === countryCode) ??
        vatRates.find(r => r.countryCode === "DE");
    return countryRates.rates;
};
export const getVatParameters = (countryCode = "DE", rateType = "standard", rate) => {
    let vatRate, vatCountryCode, vatRateType;
    const countryRates = vatRates.find(r => r.countryCode === countryCode) ??
        vatRates.find(r => r.countryCode === "DE");
    vatCountryCode = countryRates.countryCode;
    if (rateType === "custom") {
        if (rate !== null && rate !== undefined) {
            vatRateType = "custom";
            vatRate = rate;
        }
        else {
            vatRateType = "standard";
            vatRate = countryRates.rates.standard;
        }
    }
    else {
        if (rateType in countryRates.rates) {
            if (rate !== null &&
                rate !== undefined &&
                rate !== countryRates.rates[rateType]) {
                // current rate is outdated! setting to 'custom'
                vatRateType = "custom";
                vatRate = rate;
            }
            else {
                vatRateType = rateType;
                vatRate = countryRates.rates[rateType];
            }
        }
        else {
            vatRateType = "standard";
            vatRate = countryRates.rates.standard;
        }
    }
    return {
        rate: vatRate,
        countryCode: vatCountryCode,
        rateType: vatRateType,
    };
};
//# sourceMappingURL=utils.js.map